import React, { useEffect, useRef, useState } from "react"

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet"
import PropTypes from "prop-types"

// TODO make the width and height styled components
const MapPin = ({ pins = [], width = "50em", height = "50em" }) => {
  const [done, setDone] = useState(false)
  const markerRefs = useRef({})

  useEffect(() => {
    if (done) {
      Object.values(markerRefs.current).map((marker) => {
        marker.openPopup()
      })
    }
  }, [done])

  return (
    <MapContainer
      center={pins.length > 0 ? [pins[0].latitude, pins[0].longitude] : [0, 0]}
      zoom={3}
      scrollWheelZoom={true}
      style={{
        height: `${height}`,
        width: `${width}`,
      }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {pins &&
        pins.length > 0 &&
        pins.map((pin, i) => (
          <Marker
            ref={(ref) => {
              markerRefs.current[pin.id] = ref
              if (i === pins.length - 1 && !done) {
                setDone(true)
              }
            }}
            key={i}
            position={[pin.latitude, pin.longitude]}
          >
            <Popup>{pin.content}</Popup>
          </Marker>
        ))}
    </MapContainer>
  )
}

MapPin.propTypes = {
  pins: PropTypes.array, // [{latitude: 0, longitude: 0, content: "test"}]
  width: PropTypes.string,
  height: PropTypes.string,
}

export default MapPin
